import React, { useState, useEffect, useCallback, useMemo } from "react";
import { toast } from "react-toastify";
import DeleteModal from "../../components/common/deleteModal";
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Form,
  Row,
} from "reactstrap";
import BreadCrumb from "../../components/common/breadCrumb";
import Widgets from "../dashboard/widgets";
import { Formik, useFormik } from "formik";
import * as Yup from "yup";
import { InputPlaceHolder, SelectPlaceHolder, validationMessages } from "../../utils/helpers/validationMasseges";
import TableContainer from "../../components/common/tableContainer";
import {
  editDamagedResources,
  listOfDamagedResources,
  listOfResourcesManageFilter,
  resourcesAllocation,
} from "../../api/resourcesApi";
import { countOfData, findDevicesNumber } from "../../api/commonApi";
import { getId } from "../../utils/helpers/custom";
import { DamagedResourceStatus,  ListOfDevice } from "../../utils/helpers/enums";
import Loader from "../../components/common/loader";
import { listOfEmployee } from "../../api/bdeApi";
import { checkStatusCodeSuccess, CommonLabel, dateFormat, HandleResponse, TableSortFunction } from "../../utils/helpers/common";
import { ResourceLabel, ResourceStatus } from "../../common/constant/Resource";
import BaseButton from "../../components/BaseComponents/BaseButton";
import { BaseSelect } from "../../components/BaseComponents/BaseSelect";
import BaseInput from "../../components/BaseComponents/BaseInput";
import BaseModal from "../../components/BaseComponents/BaseModal";
import { Tooltip as ReactTooltip } from "react-tooltip";
import { Link } from "react-router-dom";

const DamageDevice = () => {
  document.title = ResourceLabel.DamagedResources;
  const [loading, setLoading] = useState(false);
  const [isLoading, setISLoading] = useState(false);
  const [damageResourcesCardData, setDamageResourcesCardData] = useState("");
  const [filterDetails, setFilterDetails] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [modalTodo, setModalTodo] = useState(false);
  const [device, setDevice] = useState([]);
  const [damagedDeviceList, setDamagedDeviceList] = useState([]);
  const [damagedFilteredDeviceList, setDamagedFilteredDeviceList] = useState();
  const [employeeList, setEmployeeList] = useState([]);
  const [todo, setTodo] = useState(null);
  const [selectedDamagesStatusMap, setSelectedDamagesStatusMap] = useState({});
  const [selectedEditDamagedPayload, setSelectedEditDamagedPayload] = useState();
  const [isEnabled, setIsEnabled] = useState(true);
  const [modalLoader, setModalLoader] = useState(false);
  const [tableLoader, setTableLoader] = useState(false);
  const [statusData, setStatusData] = useState(null);
  const [statusModal, setStatusModal] = useState(false);

  const WidgetData = [
    {
      id: 1,
      cardColor: "primary",
      label: ResourceLabel.DamagedResources,
      badgeClass: "success",
      counter: damageResourcesCardData,
      bgcolor: "success",
      icon: " bx bx-bug",
      decimals: 0,
      prefix: "",
      suffix: "",
    },
  ];

  const handleStatusChange = (rowIndex, selectedOption) => {
    setSelectedDamagesStatusMap(prevState => ({
      ...prevState,
      [rowIndex]: selectedOption
    }));
  };

  const handleDeleteTodo = () => {
    if (todo) {
      setDeleteModal(false);
    }
  };

  const AddDamagedDevice = () => {
    setTodo("");
    setModalTodo(!modalTodo);
    toggle();
  };

  const toggle = useCallback(() => {
    if (modalTodo) {
      setModalTodo(false);
      setTodo(null);
    } else {
      setModalTodo(true);
    }
  }, [modalTodo]);

  function listOfDamagedResourcesList() {
    setTableLoader(true);
    listOfDamagedResources()
    .then((resp) => {
      if (checkStatusCodeSuccess(resp?.data?.statusCode)) {
      setDamagedDeviceList(resp?.data?.data);
      } else {
        toast.error(resp?.data?.message);
      }
    })
    .catch((err) => err)
    .finally(() => {
      setTableLoader(false);
    });
  countOfData({
    modelName: "resourcesDetailsModel",
    condition: {
      status: ResourceStatus.Damage,
    },
  })
    .then((res) => {
      setDamageResourcesCardData(res?.data?.data);
    })
    .catch((err) => err)
    .finally(() => {
      setLoading(false);
    });
  }

  const fetchData = () => {
    setLoading(true);
    listOfDamagedResourcesList()
    listOfEmployee({
      isDeleted: false,
    })
      .then((resp) => {
        setEmployeeList(resp?.data?.map((status) => ({
          value: status?.id,
          label: `${status?.firstName} ${status?.lastName}`,
        })))
      })
      .catch((err) => err)
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchData();
  }, []);

  const validation = useFormik({
    enableReinitialize: true,

    initialValues: {
      resourceNo: todo?.resourceNo || "",
      resourceName: todo?.resourceName || "",
      reason: todo?.reason || "",
      assignTo: todo?.assignTo || "",
    },
    validationSchema: Yup.object({
      resourceNo: Yup.string().required(validationMessages.required(ResourceLabel.ResourceNo)),
      reason: Yup.string().required(validationMessages.required(ResourceLabel.Reason)),
      assignTo: Yup.string().required(validationMessages.required(ResourceLabel.HolderName)),
      resourceName: Yup.string().required(validationMessages.required(ResourceLabel.ResourceName)),
    }),
    onSubmit: (values) => {
      setModalLoader(true);
      const damagePayload = {
        resourceDetailsId: values.resourceNo,
        assignTo: parseInt(values.assignTo, 10),
        addedBy: parseInt(getId(), 10),
        remark: values.reason,
        status: ResourceStatus.Damage,
      };
      resourcesAllocation(damagePayload)
        .then((res) => {
          if (checkStatusCodeSuccess(res?.data?.statusCode)) {
            toast.success(res?.data?.message);
            fetchData();
            validation.resetForm();
            toggle();
          } else {
            toast.error(res?.data?.message);
          }
        })
        .catch((err) => toast.error(err))
        .finally(() => {
          setModalLoader(false);
        });
    },
  });

  const validationFilter = useFormik({
    enableReinitialize: true,

    initialValues: {
      resourceNo: "",
      resourceName: "",
      employeeName: "",
    },
    validationSchema: Yup.object({
      resourceNo: Yup.string().optional(),
      developerName: Yup.string().optional(),
      employeeName: Yup.string().optional(),
    }),
    onSubmit: (value) => {
      const payload = {
        ...value,
        resourceNo: device?.find((item)=> item?.value===value?.resourceNo)?.label,
        ...(value?.employeeName && {
          employeeName: employeeList?.find((item) => item?.value === value?.employeeName)?.label,
        }),
      };
      setTableLoader(true);
      listOfResourcesManageFilter(payload)
        .then((resp) => {
          if (checkStatusCodeSuccess(resp?.data?.statusCode)) {
            setDamagedFilteredDeviceList(resp?.data?.data);
          } else {
            setDamagedFilteredDeviceList([]);
          }
        })
        .catch((err) => {
          setDamagedFilteredDeviceList([]);
          return err;
        })
        .finally(() => {
          setTableLoader(false);
        });
    },
  });

  const validationStatusFilter = useFormik({
    enableReinitialize: true,

    initialValues: {
      damageResourceStatus: "",
    },
    validationSchema: Yup.object({
      damageResourceStatus: Yup.string().optional(),
    }),
    onSubmit: (values) => {
      setModalLoader(true);
      let obj;

      if (selectedEditDamagedPayload !== undefined || selectedEditDamagedPayload !== null) {
        let damagedStatus;
        if (selectedDamagesStatusMap[selectedEditDamagedPayload?.id]) {
          damagedStatus = selectedDamagesStatusMap[selectedEditDamagedPayload?.id];
        }
        obj = {
          resourceDetailsId: selectedEditDamagedPayload?.resourcesDetails?.id,
          resourceAssignId: selectedEditDamagedPayload?.id,
          status: values?.damageResourceStatus || damagedStatus,
        }
      }
      setISLoading(true);
      editDamagedResources(obj)
        .then((resp) => { 
          if (resp?.data) {
            setStatusModal(false);
            listOfDamagedResources()
            .then((resp) => {
              if (checkStatusCodeSuccess(resp?.data?.statusCode)) {
              setDamagedDeviceList(resp?.data?.data);
              countOfData({
                modelName: "resourcesDetailsModel",
                condition: {
                  status: ResourceStatus.Damage,
                },
              })
                .then((res) => {
                  setDamageResourcesCardData(res?.data?.data);
                })
                .catch((err) => err)
                .finally(() => {
                  setLoading(false);
                });
              } else {
                toast.error(resp?.data?.message);
              }
            })
            .catch((err) => err)
              toast.success(resp?.data?.message);
            }
        })
        .catch((err) => err)
        .finally(() => {
          setModalLoader(true);
        });
    },
  });

  const damagedDevicesStatusColumns = useMemo(() => [
    {
      Header: ResourceLabel.HolderName,
      accessor: "resourcesAssign.authUser.developerName",
      filterable: false,
      sortType: (rowA, rowB) =>
        TableSortFunction(rowA, rowB, "resourcesAssign.authUser.developerName"),
    },
    {
      Header: ResourceLabel.ResourceName,
      accessor: "resourcesDetails.resourceName",
      filterable: false,
    },
    {
      Header: ResourceLabel.ResourceNo,
      accessor: "resourcesDetails.resourceNo",
      filterable: false,
    },
    {
      Header: ResourceLabel.IntegrityDate,
      accessor: "resourcesAssign.createdAt",
      filterable: false,
      Cell: (cell) => {
        const date = cell?.row?.original?.resourcesAssign?.createdAt;
        return (
          <div>
            {dateFormat(date) !== CommonLabel.InvalidDate
              ? dateFormat(date)
              : HandleResponse.NoData}
          </div>
        );
      },
      sortType: (rowA, rowB) =>
        TableSortFunction(rowA, rowB, "resourcesAssign.createdAt"),
    },
    {
      Header: ResourceLabel.ManageDate,
      accessor: "damageDate",
      filterable: false,
      Cell: (cell) => {
        const date = cell?.row?.original?.damageDate;
        return (
          <div>
            {dateFormat(date) !== CommonLabel.InvalidDate
              ? dateFormat(date)
              : HandleResponse.NoData}
          </div>
        );
      },
    },
    {
      Header: CommonLabel.Status,
      accessor: "status",
      filterable: false,
      sortType: (rowA, rowB) =>
        TableSortFunction(rowA, rowB, "resourcesManage.0.status"),
    },
  ]);

  const damagedDevicesColumns = useMemo(() => [
    {
      Header: ResourceLabel.HolderName,
      accessor: "authUser.firstName",
      filterable: false,
      Cell: (cell) => {
        return `${cell?.row?.original?.authUser?.firstName} ${cell?.row?.original?.authUser?.lastName}`;
      },
      sortType: (rowA, rowB) => 
        TableSortFunction(rowA, rowB, (row) =>
        `${row?.original?.authUser?.firstName} ${row?.original?.authUser?.lastName}`.toLowerCase()
      ),
    },
    {
      Header: ResourceLabel.ResourceName,
      accessor: "resourcesDetails.resourceName",
      filterable: false,
      Cell: (cell) => {
        return cell?.row?.original?.resourcesDetails?.resourceName;
      },
    },
    {
      Header: ResourceLabel.ResourceNo,
      accessor: "resourcesDetails.resourceNo",
      filterable: false,
      Cell: (cell) => {
        return cell?.row?.original?.resourcesDetails?.resourceNo;
      },
    },
    {
      Header: ResourceLabel.IntegrityDate,
      accessor: "",
      filterable: false,
      Cell: (cell) => {
        const date = cell?.row?.original?.createdAt;
        return (
          <div>
            {dateFormat(date) !== CommonLabel.InvalidDate
              ? dateFormat(date)
              : HandleResponse.NoData}
          </div>
        );
      },
      sortType: (rowA, rowB) =>
        TableSortFunction(rowA, rowB, "createdAt"),
    },
    {
      Header: ResourceLabel.Reason,
      accessor: "resourcesManage?.[0]?.remark",
      Cell: (cell) => {
        const remark = cell?.row?.original?.resourcesManage?.[0]?.remark;
        return <div>{remark || HandleResponse.NoData}</div>;
      },
      filterable: false,
      sortType: (rowA, rowB) => TableSortFunction(rowA, rowB, "resourcesManage.0.remark"),
    },
    {
      Header: CommonLabel.Status,
      accessor: "resourcesManage?.[0]?.status",
      Cell: (cell) => {
        const status = cell?.row?.original?.resourcesManage?.[0]?.status;
        return <div>{status || HandleResponse.NoData}</div>;
      },
      filterable: false,
      sortType: (rowA, rowB) => TableSortFunction(rowA, rowB, "resourcesManage.0.status"),
    },
    {
      Header: CommonLabel.Action,
      Cell: (cell) => {
        const rowIndex = cell?.row?.original?.id;
        const isEnabled =
          cell?.row?.original?.resourcesManage?.[0]?.status ===
          CommonLabel.Success
            ? true
            : false;
        let preFilledValue = cell?.row?.original?.resourcesManage?.[0]?.status;
        return (
          <div className="hstack gap-2">
            {!isEnabled && (
              <>
              <Link
                id={`detailedView-${rowIndex}`}
                className="btn btn-sm btn-soft-info"
                onClick={() => {
                  handleStatusModal(rowIndex, preFilledValue, cell?.row?.original);
                }}
                disable={isEnabled}
              >
                <i className="ri-booklet-line align-bottom" />
              </Link>
              <ReactTooltip
                place="bottom"
                variant="info"
                content={CommonLabel.Status}
                anchorId={`detailedView-${rowIndex}`}
              />
              </>
            )}
          </div>
        );
      },
      filterable: false,
    },
  ]);

  const handleStatusModal = (index, value, rowData) => {
    setStatusModal(true);
    const status = {
      rowIndex: index,
      data: value,
      rowData: rowData,
    }
    setStatusData(status);
  }
  function findResourceName(resourceData, status) {
    findDevicesNumber({
      resourceName: resourceData,
    }).then((res) => {
      setIsEnabled(false);
      setDevice(res?.data?.data?.map((status) => ({
        value: status?.id,
        label: status?.resourceNo,
      })));
    });
  }
  
  const statusToggle = () => {
    setStatusModal(false);
    validationStatusFilter.resetForm();
  }
  return (
    <React.Fragment>
      <DeleteModal
        show={deleteModal}
        onDeleteClick={() => handleDeleteTodo()}
        onCloseClick={() => setDeleteModal(false)}
      />
      <div className="page-content">
          <Container fluid>
            <BreadCrumb title="Damaged Resources" pageTitle="HRMS" />
            <Row className="mb-2">
              <div className="col-sm order-3 order-sm-2 mt-3 mt-sm-0">
                <h5 className="fw-semibold mt-2">{ResourceLabel.DamagedResources}</h5>
              </div>

              <div className="col-auto order-2 order-sm-3 ms-auto">
                <div className="hstack gap-2">
                  <BaseButton
                    color="primary"
                    type="button"
                    onClick={() => AddDamagedDevice()}>
                    <i className="ri-add-line mt-2" />
                    {ResourceLabel.DamagedResources}
                  </BaseButton>
                </div>
              </div>
            </Row>
            <Row>
              <Widgets data={WidgetData} />
            </Row>
            <Card>
              <CardBody className="mt-0">
                <Formik
                  initialValues={validationFilter.initialValues}
                  validationSchema={validationFilter.validationSchema}
                  onSubmit={validationFilter.handleSubmit}>
                  <Form onSubmit={validationFilter.handleSubmit}>
                    <Row>
                      <Col>
                        <div className="p-2">
                          <BaseSelect
                            name="resourceName"
                            placeholder={SelectPlaceHolder(ResourceLabel.ResourceName)}
                            options={ListOfDevice}
                            value={validationFilter.values.resourceName}
                            handleChange={(field, value) => {
                              validationFilter.setFieldValue(field, value);
                              findResourceName(value, [ResourceStatus.Damage, ResourceStatus.Repair, ResourceStatus.OnProcess, ResourceStatus.Fail, ResourceStatus.Success]);
                            }}
                            handleBlur={validationFilter.handleBlur}
                            touched={validationFilter.touched?.resourceName}
                            error={validationFilter.errors?.resourceName}
                          />
                        </div>
                      </Col>
                      <Col>
                        <div className="p-2">
                          <BaseSelect
                            name="resourceNo"
                            placeholder={SelectPlaceHolder(ResourceLabel.ResourceNo)}
                            options={device}
                            value={validationFilter.values.resourceNo}
                            handleChange={(field, value) => {
                              validationFilter.setFieldValue(field, value);
                            }}
                            handleBlur={validationFilter.handleBlur}
                            touched={validationFilter.touched?.resourceNo}
                            error={validationFilter.errors?.resourceNo}
                          />
                        </div>
                      </Col>
                      <Col>
                        <div className="p-2">
                          <BaseSelect
                            name="employeeName"
                            placeholder={SelectPlaceHolder(ResourceLabel.HolderName)}
                            options={employeeList}
                            value={validationFilter.values.employeeName}
                            handleChange={(field, value) => {
                              validationFilter.setFieldValue(field, value);
                            }}
                            handleBlur={validationFilter.handleBlur}
                            touched={validationFilter.touched?.employeeName}
                            error={validationFilter.errors?.employeeName}
                          />
                        </div>
                      </Col>
                      <Col>
                        <div className="mt-2 d-flex gap-2">
                          <BaseButton
                            color="primary"
                            type="button"
                            onClick={() => {
                              validationFilter.handleSubmit();
                              setFilterDetails(true);
                            }
                            }
                          >
                            {CommonLabel.Filter}
                          </BaseButton>
                          <BaseButton
                            color="soft-danger"
                            type="button"
                            onClick={() => {
                              validationFilter.resetForm();
                              setFilterDetails(false);
                            }
                            }
                          >
                            <i className="ri-close-line align-bottom me-1"></i>
                            {CommonLabel.Clear}
                          </BaseButton>
                        </div>
                      </Col>
                    </Row>
                  </Form>
                </Formik>
              </CardBody>
            </Card>
            <div className="todo-task" id="todo-task">
              <Card>
                <CardHeader className="align-items-center d-flex">
                  <h4 className="card-title mb-0 flex-grow-1">
                    {ResourceLabel.DamagedResources}
                  </h4>
                </CardHeader>
                <CardBody>
                    {filterDetails && (
                      <TableContainer
                        columns={damagedDevicesStatusColumns}
                        data={damagedFilteredDeviceList || []}
                        isAddUserList={false}
                        isGlobalFilter={false}
                        customPageSize={5}
                        tableLoader={tableLoader}
                        divClass="table-responsive table-card mb-1"
                        tableClass="align-middle table-nowrap"
                        theadClass="table-light text-muted"
                      />
                    )}
                  {filterDetails === false && (
                    <TableContainer
                      columns={damagedDevicesColumns}
                      data={damagedDeviceList || []}
                      isAddUserList={false}
                      isGlobalFilter={false}
                      customPageSize={5}
                      tableLoader={tableLoader}
                      divClass="table-responsive table-card mb-1"
                      tableClass="align-middle table-nowrap"
                      theadClass="table-light text-muted"
                    />
                  ) 
                  }
                </CardBody>
              </Card>
            </div>
          </Container>
      </div>
      <BaseModal
        open={modalTodo}
        onClose={() => setModalTodo(false)}
        toggle={toggle}
        className="zoomIn"
        title={ResourceLabel.AddDamagedResources}
        bodyClassName="p-4"
        submit={validation.handleSubmit}
        submitLabel={CommonLabel.Submit}
        submitLabelColor="primary"
        closeLabel={CommonLabel.Cancel}
        loader={modalLoader}
        closeLabelColor="ghost-success"
      >
        <div id="task-error-msg" className="alert alert-danger py-2"></div>
        <Form
          id="creattask-form"
          onSubmit={(e) => {
            e.preventDefault();
            validation.handleSubmit();
            return false;
          }}
        >
          <div className="mb-3">
            <BaseSelect
              name="resourceName"
              label={ResourceLabel.ResourceName}
              placeholder={SelectPlaceHolder(ResourceLabel.ResourceName)}
              options={ListOfDevice}
              value={validation.values.resourceName}
              handleChange={(field, value) => {
                validation.setFieldValue(field, value);
                findResourceName(value, [ResourceStatus.Allocation, ResourceStatus.Available, ResourceStatus.Return]);
              }}
              handleBlur={validation.handleBlur}
              touched={validation.touched?.resourceName}
              error={validation.errors?.resourceName}
              required
            />
          </div>

          <div className="mb-3">
            <BaseSelect
              name="resourceNo"
              label={ResourceLabel.ResourceNo}
              placeholder={SelectPlaceHolder(ResourceLabel.ResourceNo)}
              options={device}
              value={validation.values.resourceNo}
              handleChange={(field, value) => {
                validation.setFieldValue(field, value);
              }}
              handleBlur={validation.handleBlur}
              touched={validation.touched?.resourceNo}
              error={validation.errors?.resourceNo}
              isDisabled={isEnabled}
              required
            />
          </div>

          <div className="mb-3">
            <BaseSelect
              name="assignTo"
              label={ResourceLabel.HolderName}
              placeholder={SelectPlaceHolder(ResourceLabel.HolderName)}
              options={employeeList}
              value={validation.values.assignTo}
              handleChange={(field, value) => {
                validation.setFieldValue(field, value);
              }}
              handleBlur={validation.handleBlur}
              touched={validation.touched?.assignTo}
              error={validation.errors?.assignTo}
              required
            />
          </div>

          <div className="mb-3">
            <BaseInput
              name="reason"
              type="text"
              label={ResourceLabel.Reason}
              placeholder={InputPlaceHolder(ResourceLabel.Reason)}
              onChange={validation.handleChange}
              handleBlur={validation.handleBlur}
              value={validation.values.reason}
              touched={validation.touched.reason}
              error={validation.errors.reason}
              required
            />
          </div>
        </Form>
      </BaseModal>
      <BaseModal
        open={statusModal}
        onClose={() => statusToggle()}
        toggle={() => statusToggle()}
        className="zoomIn"
        title={CommonLabel.Status}
        bodyClassName="p-4"
        submit={validationStatusFilter.handleSubmit}
        submitLabel={CommonLabel.Submit}
        submitLabelColor="primary"
        closeLabel={CommonLabel.Cancel}
        loader={modalLoader}
        closeLabelColor="ghost-success"
      >
        <BaseSelect
          name="damageResourceStatus"
          label={CommonLabel.Status}
          placeholder={SelectPlaceHolder(CommonLabel.Status)}
          options={DamagedResourceStatus}
          value={
            validationStatusFilter?.values?.damageResourceStatus ||
            statusData?.data
          }
          handleChange={(field, value) => {
            setSelectedEditDamagedPayload(statusData?.rowData);
            handleStatusChange(statusData?.rowIndex, value);
            validationStatusFilter.setFieldValue(field, value);
          }}
          handleBlur={validationStatusFilter.handleBlur}
          touched={validationStatusFilter.touched?.damageResourceStatus}
          error={validationStatusFilter.errors?.damageResourceStatus}
          required
        />
      </BaseModal>
    </React.Fragment>
  );
};

export default DamageDevice;
